import React, { useState, useEffect, useRef } from 'react';
import JessibucaPlayer from '@/components/JessibucaPlayer';
import WebRTCComponent from '@/components/JFWebRTCTalk';
import styles from './style.less';
import { useRequest, request, useLocation } from 'umi';
import screenfull from 'screenfull';
import {
  CaretUpOutlined,
  CaretRightOutlined,
  CaretDownOutlined,
  CaretLeftOutlined,
  AudioOutlined,
  SettingOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { message, Popconfirm, Tag } from 'antd';
import 'recorder-core/recorder.mp3.min';
import RecordApp from 'recorder-core/src/app-support/app';

let apiPrefix = 'https://open.mokan.cn';
let startRecording = false;

const Live = () => {
  const location = useLocation();
  const {
    type,
    deviceId,
    serialNumber,
    timestamp,
    clientCode,
    sign,
    hideYun,
    hideVoiceBtn,
    fullbox,
    text1,
    text2,
    text3,
    talkback,
    setPresetPosition, //预置位
  } = location.query;

  const playerRef = useRef();
  // const recorder = useRef();
  const [isMute, setIsMute] = useState(true);
  const [isHD, setIsHD] = useState(false);
  const [url, setUrl] = useState('');
  const playerContainer = useRef();
  const [isRecording, setIsRecording] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(screenfull.isFullscreen);
  const [openDefYZW, setOpenDefYZW] = useState(false); //默认预置位弹窗
  const [openDefLoading, setOpenDefLoading] = useState(false); //设置默认loading
  const [showTag, setShowTag] = useState(false); // 有无预置位
  // const [isPause, setIsPause] = useState(false);
  const hasYzw = setPresetPosition && setPresetPosition != 'false';
  const [deviceInfo, setDeviceInfo] = useState(null); //设备信息

  useEffect(() => {
    hasYzw &&
      _getYzw().then((res) => {
        setShowTag(!res.data);
      });
    return () => {
      // RecordApp.Close();
    };
  }, []);

  if (type === 'test') {
    apiPrefix = 'https://test-open.mokan.cn';
  }

  const tempObj = {};
  if (serialNumber) {
    tempObj.serialNumber = serialNumber;
  } else if (deviceId) {
    tempObj.deviceId = deviceId;
  }
  useEffect(() => {
    if (url) {
      getDeviceInfo().then((res) => {
        setDeviceInfo(res.data);
      });
    }
  }, [url]);

  //用于判断是不是杰峰的设备
  const startsWithExcludedString = (inputString) => {
    if (!inputString) return;
    //是JF返回true，不是则返回false，可设置多个平台前缀
    let excludedStrings = ['JF_'];
    for (let excludedString of excludedStrings) {
      if (inputString.startsWith(excludedString)) {
        return true;
      }
    }

    return false;
  };
  //杰峰设备保活
  function _JFdeviceLogin(params) {
    return request(`${apiPrefix}/openapi/video/deviceLogin`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params,
    });
  }
  function _JFdeviceKeepAlive(params) {
    return request(`${apiPrefix}/openapi/video/deviceKeepAlive`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params,
    });
  }
  //杰峰的设备，保活逻辑，每隔20秒调用一次
  useEffect(() => {
    let intervalId;

    const handleDeviceLogin = async () => {
      try {
        await _JFdeviceLogin({ serialNumber: deviceInfo.serialNumber });
        // 登录成功后，设置定时器每隔20秒调用_JFdeviceKeepAlive
        intervalId = setInterval(() => {
          _JFdeviceKeepAlive({ serialNumber: deviceInfo.serialNumber });
        }, 20000);
      } catch (error) {
        // console.error('设备登录失败:', error);
      }
    };

    if (deviceInfo && startsWithExcludedString(deviceInfo?.deviceType)) {
      handleDeviceLogin();
    }

    // 清除定时器
    return () => {
      clearInterval(intervalId);
    };
  }, [deviceInfo]);
  const _startStream = ({ voice, resolution }) => {
    if (!tempObj.deviceId && !tempObj.serialNumber) {
      return message.error('参数缺失');
    }
    return request(`${apiPrefix}/openapi/video/startStream`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: {
        ...tempObj,
        force: true,
        voice,
        resolution,
      },
    });
  };

  const _mqtt = (cmd) => {
    return request(`${apiPrefix}/openapi/video/cloudDeckControl`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      data: {
        ...tempObj,
        cmd,
      },
    });
  };

  const { data, loading } = useRequest(
    () => {
      return _startStream({
        voice: false,
        resolution: 0,
      });
    },
    {
      onSuccess(response) {
        setUrl(response.data.flvs);
        // setIsPause(true);
      },
    },
  );
  const [msgss, setmsg] = useState([111111111111111]);
  const recReq = () => {
    RecordApp.RequestPermission(
      () => {
        startRecording = true;
        setIsRecording(true);
        recStart();
        console.info('已获得录音权限，可以开始录音了', 2);
        setmsg([...msgss, '已获得录音权限，可以开始录音了']);
      },
      (msg, isUserNotAllow) => {
        if (isUserNotAllow) {
          //用户拒绝了录音权限
          console.info('用户拒绝了录音权限', 2);
          setmsg([...msgss, '用户拒绝了录音权限']);
        }
      },
    );
  };

  const recStart = () => {
    RecordApp.Start(
      {
        // type: 'g711a',
        // sampleRate: 16000,
        // bitRate: 16,
      },
      () => {
        console.info('录音中recStart', 1);
        setmsg([...msgss, '录音中recStart']);
      },
      (msg) => {
        console.info('开始录音失败：' + msg, 1);
        setmsg([...msgss, '开始录音失败：']);
      },
    );
  };

  function recStop() {
    if (!startRecording) return;
    console.info('正在结束录音...');
    setmsg([...msgss, '正在结束录音']);
    RecordApp.Stop(
      (aBuf, duration, mime) => {
        if (typeof Blob != 'undefined' && typeof window == 'object') {
          var blob = new Blob([aBuf], { type: mime });
          // console.log(blob);
          _playAudioFile({
            file: blob,
          })
            .then(() => {
              message.success('上传成功');
            })
            .catch((err) => {
              message.error('上传失败');
            });
        }
      },
      (msg) => {
        console.info('结束录音失败：' + msg, 1);
        setmsg([...msgss, '结束录音失败：']);
      },
    );
    setIsRecording(false);
    startRecording = false;
  }
  function _playAudioFile(data) {
    const objData = new FormData();
    objData.append('deviceId', deviceId || deviceInfo?.id);
    objData.append('file', data.file);
    return request(`${apiPrefix}/openapi/video/playAudioFile`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      data: objData,
    });
  }

  function _setPtz(obj) {
    const objData = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      objData.append(key, value);
    }
    return request(`${apiPrefix}/openapi/video/setDefaultPtz`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      data: objData,
    });
  }

  function _goPlace() {
    return request(`${apiPrefix}/openapi/video/gotoDefaultPlace`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }

  function _getYzw() {
    return request(`${apiPrefix}/openapi/video/getDefaultPtzStatus`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }

  // 操作预置位
  const handleYZW = () => {
    setOpenDefLoading(true);
    playerRef.current?.screenshot((blob) => {
      if (blob) {
        let obj = {
          ...tempObj,
          img: blob,
        };
        _setPtz(obj)
          .then(() => {
            message.success('操作成功');
            setOpenDefLoading(false);
            setShowTag(false);
          })
          .catch(() => {
            setOpenDefLoading(false);
          });
      } else {
        message.success('请稍后重试');
      }
    });
  };

  if (!data) {
    return null;
  }
  function getDeviceInfo() {
    return request(`${apiPrefix}/openapi/ai/getDeviceInfo`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }

  return (
    <div className={styles.container}>
      <div className={fullbox ? 'fullbox' : 'player-box'} ref={playerContainer}>
        <div className="play">
          <div className="player">
            <JessibucaPlayer url={url} ref={playerRef} />
          </div>
        </div>
        {showTag && (
          <Tag color="blue" className="yzw-tag">
            无预置位
          </Tag>
        )}
        {!hideYun && (
          <div className="mq">
            <CaretUpOutlined
              onClick={() => {
                _mqtt('cloud_deck_up');
              }}
              className="icon"
            />

            <div className="center">
              <CaretLeftOutlined
                onClick={() => {
                  _mqtt('cloud_deck_left');
                }}
                className="icon"
              />

              <CaretRightOutlined
                onClick={() => {
                  _mqtt('cloud_deck_right');
                }}
                className="icon"
              />
            </div>

            <CaretDownOutlined
              onClick={() => {
                _mqtt('cloud_deck_down');
              }}
              className="icon"
            />
          </div>
        )}
        <div className="projectInfo">
          {serialNumber != 'null' && serialNumber != 'undefined' && (
            <div>设备号：{serialNumber}</div>
          )}
          {text1 != 'null' && text1 != 'undefined' && <div>{text1}</div>}
          {text2 != 'null' && text2 != 'undefined' && <div>{text2}</div>}
          {text3 != 'null' && text3 != 'undefined' && <div>{text3}</div>}
        </div>
        <div className="bar">
          <div className="left">
            {/* {!talkback || talkback == 'false' ? (
              ''
            ) : (
              <div
                className="btn"
                onMouseLeave={() => recStop()}
                onMouseDown={() => recReq()}
                onMouseUp={() => recStop()}
              >
                <AudioOutlined />
                {isRecording ? '松开发送' : '按住喊话'}
              </div>
            )} */}

            {!talkback || talkback == 'false' ? (
              ''
            ) : (
              <>
                {startsWithExcludedString(deviceInfo?.deviceType) ? (
                  <WebRTCComponent
                    serialNumber={serialNumber}
                    deviceId={deviceId || deviceInfo?.id}
                    timestamp={timestamp}
                    clientCode={clientCode}
                    sign={sign}
                    apiPrefix={apiPrefix}
                  />
                ) : (
                  <div
                    className="btn"
                    onMouseLeave={() => recStop()}
                    onMouseDown={() => recReq()}
                    onMouseUp={() => recStop()}
                  >
                    <AudioOutlined />
                    {isRecording ? '松开发送' : '按住喊话'}
                  </div>
                )}
              </>
            )}
            {hasYzw && (
              <>
                <Popconfirm
                  open={openDefYZW}
                  onOpenChange={(newOpen) => setOpenDefYZW(newOpen)}
                  title="是否设置预置位，确认后将当前位置设置为预置位？"
                  onConfirm={() => {
                    handleYZW(true);
                  }}
                  okButtonProps={{ loading: openDefLoading }}
                >
                  <span className="btn">
                    <SettingOutlined /> 设置预置位
                  </span>
                </Popconfirm>
                {showTag ? (
                  <span
                    className="btn"
                    onClick={() => {
                      message.error('设备无预置位，请先设置');
                    }}
                  >
                    <SyncOutlined /> 复位
                  </span>
                ) : (
                  <Popconfirm
                    title="你确定回到预置位吗？"
                    onConfirm={() => {
                      _goPlace().then(() => {
                        message.success('操作成功，正在回到预置位');
                      });
                    }}
                    okText="确定"
                    cancelText="取消"
                  >
                    <span className="btn">
                      <SyncOutlined /> 复位
                    </span>
                  </Popconfirm>
                )}
              </>
            )}
          </div>
          <div className="right">
            {isHD ? (
              <img
                className="icon"
                src={require('@/assets/hd.png')}
                onClick={() => {
                  _startStream({
                    voice: !isMute,
                    resolution: 0,
                  }).then((response) => {
                    setUrl(response.data.flvs);
                  });
                  setIsHD(false);
                }}
              />
            ) : (
              <img
                className="icon"
                src={require('@/assets/sd.png')}
                onClick={() => {
                  _startStream({
                    voice: !isMute,
                    resolution: 1,
                  }).then((response) => {
                    setUrl(response.data.flvs);
                  });
                  setIsHD(true);
                }}
              />
            )}
            {!hideVoiceBtn && (
              <>
                {isMute ? (
                  <img
                    onClick={() => {
                      playerRef.current.cancelMute();
                      _startStream({
                        voice: true,
                        resolution: isHD ? 1 : 0,
                      }).then((response) => {
                        setUrl(response.data.flvs);
                      });
                      setIsMute(false);
                    }}
                    className="icon"
                    src={require('@/assets/mute.png')}
                  />
                ) : (
                  <img
                    onClick={() => {
                      playerRef.current.cancelMute();
                      _startStream({
                        voice: false,
                        resolution: isHD ? 1 : 0,
                      }).then((response) => {
                        setUrl(response.data.flvs);
                      });
                      setIsMute(true);
                    }}
                    className="icon"
                    src={require('@/assets/voice.png')}
                  />
                )}
              </>
            )}

            {isFullscreen ? (
              <img
                className="icon"
                src={require('@/assets/window.png')}
                onClick={() => {
                  screenfull.exit();
                  setIsFullscreen(false);
                }}
              />
            ) : (
              <img
                className="icon"
                src={require('@/assets/screenfull.png')}
                onClick={() => {
                  screenfull.request(playerContainer.current);
                  setIsFullscreen(true);
                }}
              />
            )}
          </div>
        </div>
      </div>
      {/* {
          msgss.map((ele, i) => <div key = {i} style={{color: 'red'}}>{ele}</div>)
        }  */}
    </div>
  );
};

export default () => {
  return <Live />;
  // if (navigator.userAgent.indexOf('UCBrowser') > -1) {
  //   return (
  //     <NoticeBar theme="danger">
  //       由于UC不支持播放器播放，请使用其他播放器打开当前地址
  //     </NoticeBar>
  //   );
  // } else {
  //   return <Live />;
  // }
};
